import {
    USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE, USER_LOGOUT,
} from '../../constants/login.constants';

export const loginRequest = (authParams, action) => ({
    type: USER_LOGIN_REQUEST,
    authParams,
    action,
});

export const loginRequestSuccess = authParams => ({
    type: USER_LOGIN_SUCCESS,
    authParams,
});

export const loginRequestFailure = error => ({
    type: USER_LOGIN_FAILURE,
    error,
});

export const logoutRequest = action => ({
    type: USER_LOGOUT, action,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/account_actions/login.actions.js